export const GET_TEAM_ALCOM_SCORES = "GET_TEAM_ALCOM_SCORES";
export const GET_TEAM_ALCOM_SCORES_SUCCESS = "GET_TEAM_ALCOM_SCORES_SUCCESS";
export const GET_TEAM_ALCOM_SCORES_FAIL = "GET_TEAM_ALCOM_SCORES_FAIL";
export const GET_SERVICE_ALCOM_SCORES = "GET_SERVICE_ALCOM_SCORES";
export const GET_SERVICE_ALCOM_SCORES_SUCCESS = "GET_SERVICE_ALCOM_SCORES_SUCCESS";
export const GET_SERVICE_ALCOM_SCORES_FAIL = "GET_SERVICE_ALCOM_SCORES_FAIL";
export const GET_UNMAPPED_RESOURCE_ALCOM_SCORES = "GET_UNMAPPED_RESOURCE_ALCOM_SCORES";
export const GET_UNMAPPED_RESOURCE_ALCOM_SCORES_SUCCESS = "GET_UNMAPPED_RESOURCE_ALCOM_SCORES_SUCCESS";
export const GET_UNMAPPED_RESOURCE_ALCOM_SCORES_FAIL = "GET_UNMAPPED_RESOURCE_ALCOM_SCORES_FAIL";
export const GET_MTTA_MTTR_METRICS = "GET_MTTA_MTTR_METRICS"
export const GET_MTTA_MTTR_METRICS_SUCCESS = "GET_MTTA_MTTR_METRICS_SUCCESS"
export const GET_MTTA_MTTR_METRICS_FAIL = "GET_MTTA_MTTR_METRICS_FAIL"
export const GET_MTTA_MTTR_METRICS_FOR_TEAMS = "GET_MTTA_MTTR_METRICS_FOR_TEAMS"
export const GET_MTTA_MTTR_METRICS_FOR_TEAMS_SUCCESS = "GET_MTTA_MTTR_METRICS_FOR_TEAMS_SUCCESS"
export const GET_MTTA_MTTR_METRICS_FOR_TEAMS_FAIL = "GET_MTTA_MTTR_METRICS_FOR_TEAMS_FAIL"
